module.exports = __webpack_public_path__ + "img/cl.65517b63.svg";